import { _ as y } from "../_vite/dynamic-import-helper.js.js";
import { computed as b, defineAsyncComponent as p, watch as E, createBlock as n, openBlock as a, resolveDynamicComponent as u, unref as d, normalizeClass as s, withCtx as o, createElementVNode as U, createElementBlock as N, createCommentVNode as v, renderSlot as i, createVNode as R } from "vue";
import { _ as g } from "./DIcon.js";
import { _ as V } from "./DLoader.js";
import { x as S, y as P } from "../vendor/lodash-es@4.17.21.js";
const F = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center pointer-events-none"
}, ue = {
  __name: "DButton",
  props: {
    tag: {
      type: String,
      default: "button",
      editable: !1
    },
    theme: {
      type: String,
      default: "primary",
      description: "Used to change the theme of the button",
      validator(e) {
        return [
          "primary",
          "primary-subtle",
          "base",
          "destructive",
          "destructive-subtle",
          "text-link",
          "transparent",
          "transparent-subtle",
          "transparent-subtle-invert",
          "outline",
          "superadmin",
          "input-alias"
        ].includes(e);
      }
    },
    linkColor: {
      type: String,
      default: "brand",
      description: "Used to change the colour for text links",
      validator(e, t) {
        return [
          "base",
          "superadmin",
          "destructive",
          "informative",
          "alert",
          "success",
          "brand"
        ].includes(e);
      }
    },
    linkUnderline: {
      type: Boolean,
      default: !0,
      description: "Used to remove the underline from text links"
    },
    linkSize: {
      type: String,
      default: "base",
      description: "Used to change the size of text links",
      validator(e, t) {
        return [
          "base",
          "lg"
        ].includes(e);
      }
    },
    size: {
      type: String,
      default: "md",
      description: "Used to change the size of the button",
      validator(e, t) {
        return [
          "sm",
          "md",
          "lg"
        ].includes(e);
      }
    },
    icon: {
      type: String,
      description: "The icon to display on the button",
      iconify: !0
    },
    iconSet: {
      type: String,
      description: "The icon set to use"
    },
    iconType: {
      type: String,
      description: "The icon type to use"
    },
    iconSize: {
      type: String,
      default: "w-5 h-5",
      description: "The size of the icon"
    },
    leftIcon: {
      type: String,
      description: "The icon to display on the left of the button",
      iconify: !0
    },
    rightIcon: {
      type: String,
      description: "The icon to display on the right of the button",
      iconify: !0
    },
    wide: {
      type: Boolean,
      description: "Makes the button full width"
    },
    disabled: {
      type: Boolean,
      description: "Disables button entirely"
    },
    active: {
      type: Boolean,
      description: "Manually control if the button is in its active state"
    },
    focused: {
      type: Boolean,
      description: "Manually control if the button is in its focused state"
    },
    border: {
      type: Boolean,
      description: "Adds a border to the button"
    },
    activeRing: {
      type: Boolean,
      default: !0,
      description: "Adds an active ring to the button when focused",
      editable: !1
    },
    loading: {
      type: Boolean,
      description: "Shows a spinner in the middle of the button, spinner inherits colors from theme prop"
    },
    stopPropagation: {
      type: Boolean,
      description: "Use the click events stopPropagation() method",
      editable: !1
    },
    preventDefault: {
      type: Boolean,
      description: "Use the click events preventDefault() method",
      editable: !1
    },
    tabindex: {
      type: String,
      default: "0",
      description: "The tabindex of the button",
      editable: !1
    }
  },
  emits: {
    click: {
      description: "Emitted when the button is clicked"
    }
  },
  setup(e, { emit: t }) {
    const r = t, c = e, f = b(() => {
      if (c.theme === "text-link")
        return "";
      switch (c.size) {
        case "sm":
          return "button-sm px-button-x-sm py-button-y-sm leading-5 button-radius-sm";
        case "lg":
          return "button-sm px-button-x-lg py-button-y-lg leading-5 button-radius-lg";
        case "md":
        default:
          return "button-sm px-button-x-base py-button-y-base leading-5 button-radius-base";
      }
    }), m = b(() => {
      switch (c.size) {
        case "lg":
          return "-mx-2.5";
        case "sm":
        case "md":
        default:
          return "-mx-1.5";
      }
    });
    let h = p(() => y(/* @__PURE__ */ Object.assign({ "./themes/Base.vue": () => Promise.resolve().then(() => k), "./themes/Destructive.vue": () => Promise.resolve().then(() => z), "./themes/DestructiveSubtle.vue": () => Promise.resolve().then(() => T), "./themes/InputAlias.vue": () => Promise.resolve().then(() => B), "./themes/Outline.vue": () => Promise.resolve().then(() => x), "./themes/Primary.vue": () => Promise.resolve().then(() => O), "./themes/PrimarySubtle.vue": () => Promise.resolve().then(() => $), "./themes/Secondary.vue": () => Promise.resolve().then(() => j), "./themes/Superadmin.vue": () => Promise.resolve().then(() => w), "./themes/TextLink.vue": () => Promise.resolve().then(() => C), "./themes/Transparent.vue": () => Promise.resolve().then(() => D), "./themes/TransparentSubtle.vue": () => Promise.resolve().then(() => M), "./themes/TransparentSubtleInvert.vue": () => Promise.resolve().then(() => I) }), `./themes/${S(P(c.theme))}.vue`, 3));
    const L = (l) => {
      c.preventDefault && l.preventDefault(), c.stopPropagation && l.stopPropagation(), !(c.disabled || c.loading) && r("click");
    };
    return E(() => c.theme, (l) => {
      h = p(() => y(/* @__PURE__ */ Object.assign({ "./themes/Base.vue": () => Promise.resolve().then(() => k), "./themes/Destructive.vue": () => Promise.resolve().then(() => z), "./themes/DestructiveSubtle.vue": () => Promise.resolve().then(() => T), "./themes/InputAlias.vue": () => Promise.resolve().then(() => B), "./themes/Outline.vue": () => Promise.resolve().then(() => x), "./themes/Primary.vue": () => Promise.resolve().then(() => O), "./themes/PrimarySubtle.vue": () => Promise.resolve().then(() => $), "./themes/Secondary.vue": () => Promise.resolve().then(() => j), "./themes/Superadmin.vue": () => Promise.resolve().then(() => w), "./themes/TextLink.vue": () => Promise.resolve().then(() => C), "./themes/Transparent.vue": () => Promise.resolve().then(() => D), "./themes/TransparentSubtle.vue": () => Promise.resolve().then(() => M), "./themes/TransparentSubtleInvert.vue": () => Promise.resolve().then(() => I) }), `./themes/${S(P(l))}.vue`, 3));
    }), (l, ae) => (a(), n(u(d(h)), {
      tag: e.tag,
      class: s(["relative inline-flex items-center gap-x-1.5 cursor-pointer focus-visible:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 transition-colors duration-75", [d(f), {
        "pointer-events-none cursor-not-allowed opacity-50": e.disabled,
        "pointer-events-none": e.loading,
        "flex-1 w-full justify-center": e.wide,
        "active:!outline-none": !e.activeRing,
        "outline outline-2 outline-offset-2 outline-[--border-brand-base]": e.focused
      }]]),
      disabled: e.disabled,
      tabindex: e.tabindex,
      active: e.active,
      focused: e.focused,
      border: e.border,
      "link-color": e.linkColor,
      "link-underline": e.linkUnderline,
      "link-size": e.linkSize,
      "d-group-border": "",
      "data-spark": "dbutton",
      "data-size": e.size,
      onClick: L
    }, {
      default: o(() => [
        U("span", {
          class: s(["inline-flex items-center gap-x-1.5 pointer-events-none", [e.loading ? "opacity-0" : "opacity-100"]])
        }, [
          e.leftIcon ? (a(), n(g, {
            key: 0,
            class: "-ml-0.5",
            icon: e.leftIcon,
            "icon-set": e.iconSet,
            type: e.iconType,
            size: e.size === "sm" ? "w-4 h-4" : "w-5 h-5"
          }, null, 8, ["icon", "icon-set", "type", "size"])) : v("", !0),
          i(l.$slots, "default", {}, () => [
            e.icon ? (a(), n(g, {
              key: 0,
              class: s(d(m)),
              icon: e.icon,
              "icon-set": e.iconSet,
              type: e.iconType,
              size: e.iconSize
            }, null, 8, ["class", "icon", "icon-set", "type", "size"])) : v("", !0)
          ]),
          e.rightIcon ? (a(), n(g, {
            key: 1,
            class: "-mr-0.5",
            icon: e.rightIcon,
            "icon-set": e.iconSet,
            type: e.iconType,
            size: e.size === "sm" ? "w-4 h-4" : "w-5 h-5"
          }, null, 8, ["icon", "icon-set", "type", "size"])) : v("", !0)
        ], 2),
        e.loading ? (a(), N("span", F, [
          R(V, { active: e.loading }, null, 8, ["active"])
        ])) : v("", !0)
      ]),
      _: 3
    }, 8, ["tag", "class", "disabled", "tabindex", "active", "focused", "border", "link-color", "link-underline", "link-size", "data-size"]));
  }
}, H = {
  __name: "InputAlias",
  props: {
    tag: String,
    active: Boolean,
    focused: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["surface-input-default hover:button-base-surface-hover active:button-base-surface-active text-ux-base ring-1 ring-inset ring-[--border-neutral-base] shadow-sm", {
        "outline outline-2 outline-offset-2 outline-[--border-focus]": e.focused,
        "!button-base-surface-active": e.active,
        "opacity-50": e.disabled
      }]),
      "d-group-border": ""
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}, B = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: H
}, Symbol.toStringTag, { value: "Module" })), A = {
  __name: "Base",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["button-base-surface-default hover:button-base-surface-hover active:button-base-surface-active button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active shadow-sm ring-1 ring-inset ring-[--button-base-border-default] hover:ring-[--button-base-border-hover] active:ring-[--button-base-border-active]", {
        "!button-base-surface-active": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, k = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: A
}, Symbol.toStringTag, { value: "Module" })), q = {
  __name: "Destructive",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["button-destructive-primary-surface-default hover:button-destructive-primary-surface-hover active:button-destructive-primary-surface-active button-destructive-primary-on-surface-default hover:button-destructive-primary-on-surface-hover active:button-destructive-primary-on-surface-active shadow-sm focus-visible:!outline-[--border-error-base]", {
        "!button-destructive-primary-surface-active": e.active,
        "!surface-secondary-strong !button-base-on-surface-neutral-default": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: q
}, Symbol.toStringTag, { value: "Module" })), G = {
  __name: "DestructiveSubtle",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["button-destructive-subtle-surface-default hover:button-destructive-subtle-surface-hover active:button-destructive-subtle-surface-active button-destructive-subtle-on-surface-default hover:button-destructive-subtle-on-surface-hover active:button-destructive-subtle-on-surface-active shadow-sm focus-visible:!outline-[--border-error-base] ring-1 ring-inset ring-[--button-destructive-subtle-border-default] hover:ring-[--button-destructive-subtle-border-hover] active:ring-[--button-destructive-subtle-border-active]", {
        "!button-destructive-subtle-surface-active": e.active,
        "!ring-transparent !surface-secondary-strong !button-base-on-surface-neutral-default": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, T = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G
}, Symbol.toStringTag, { value: "Module" })), J = {
  __name: "Outline",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["ring-1 ring-inset ring-[--button-outline-border-default] hover:ring-[--button-outline-border-hover] active:ring-[--button-outline-border-active] button-outline-surface-default hover:button-outline-surface-hover active:button-outline-surface-active button-outline-on-surface-default hover:button-outline-on-surface-hover active:button-outline-on-surface-active hover:overlay-subtle active:overlay-base shadow-sm active:outline active:outline-offset-2 active:outline-[--button-outline-border-default]", {
        "!button-outline-surface-active !button-outline-on-surface-active": e.active,
        "!ring-[--button-base-border-default] !button-base-on-surface-neutral-default": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, x = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J
}, Symbol.toStringTag, { value: "Module" })), K = {
  __name: "Primary",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["button-brand-primary-surface-default hover:button-brand-primary-surface-hover active:button-brand-primary-surface-active button-brand-primary-on-surface-default hover:button-brand-primary-on-surface-hover active:button-brand-primary-on-surface-active shadow-sm", {
        "!button-brand-primary-surface-active": e.active,
        "!surface-secondary-strong !button-base-on-surface-neutral-default": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, O = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: K
}, Symbol.toStringTag, { value: "Module" })), Q = {
  __name: "PrimarySubtle",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["button-brand-subtle-surface-default hover:button-brand-subtle-surface-hover active:button-brand-subtle-surface-active button-brand-subtle-on-surface-default hover:button-brand-subtle-on-surface-hover active:button-brand-subtle-on-surface-active shadow-sm ring-1 ring-inset ring-[--button-brand-subtle-border-default] hover:ring-[--button-brand-subtle-border-hover] active:ring-[--button-brand-subtle-border-active]", {
        "button-brand-subtle-surface-active": e.active,
        "!surface-secondary-strong !button-base-on-surface-neutral-default": e.disabled
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, $ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Q
}, Symbol.toStringTag, { value: "Module" })), W = {
  __name: "Secondary",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(A, {
      tag: e.tag,
      active: e.active,
      disabled: e.disabled
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["tag", "active", "disabled"]));
  }
}, j = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W
}, Symbol.toStringTag, { value: "Module" })), X = { class: "flex items-center text-superadmin" }, Y = {
  __name: "Superadmin",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean,
    border: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["hover:button-transparent-surface-hover active:button-transparent-surface-active button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active", {
        "is-active": e.active,
        "shadow-sm button-superadmin": e.border
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        U("span", X, [
          i(t.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["class", "disabled", "active"]));
  }
}, w = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y
}, Symbol.toStringTag, { value: "Module" })), Z = {
  __name: "TextLink",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean,
    linkColor: String,
    linkUnderline: Boolean,
    linkSize: String
  },
  setup(e) {
    const t = e, r = b(() => {
      switch (t.linkColor) {
        case "base":
          return "button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active";
        case "superadmin":
          return "text-superadmin";
        case "destructive":
          return "button-transparent-on-surface-destructive-default hover:button-transparent-on-surface-destructive-hover active:button-transparent-on-surface-destructive-active";
        case "informative":
          return "button-transparent-on-surface-information-default hover:button-transparent-on-surface-information-hover active:button-transparent-on-surface-information-active";
        case "alert":
          return "button-transparent-on-surface-alert-default hover:button-transparent-on-surface-alert-hover active:button-transparent-on-surface-alert-active";
        case "success":
          return "button-transparent-on-surface-success-default hover:button-transparent-on-surface-success-hover active:button-transparent-on-surface-success-active";
        case "brand":
        default:
          return "button-transparent-on-surface-brand-default hover:button-transparent-on-surface-brand-hover active:button-transparent-on-surface-brand-active";
      }
    }), c = b(() => {
      switch (t.linkColor) {
        case "base":
          return "!button-base-on-surface-neutral-active";
        case "superadmin":
          return "!text-superadmin";
        case "destructive":
          return "!button-transparent-on-surface-destructive-active";
        case "informative":
          return "!button-transparent-on-surface-information-active";
        case "alert":
          return "!button-transparent-on-surface-alert-active";
        case "success":
          return "!button-transparent-on-surface-success-active";
        case "brand":
        default:
          return "!button-transparent-on-surface-brand-active";
      }
    }), f = b(() => {
      switch (t.linkSize) {
        case "base":
          return "button-sm";
        case "lg":
          return "button-base";
        default:
          return "button-sm";
      }
    });
    return (m, h) => (a(), n(u(e.tag), {
      class: s(["hover:underline underline-offset-4", [d(r), d(f), {
        [d(c)]: e.active,
        underline: e.linkUnderline || e.active,
        "!opacity-50 !button-base-on-surface-neutral-default": e.disabled
      }]]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        i(m.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, C = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z
}, Symbol.toStringTag, { value: "Module" })), _ = {
  __name: "Transparent",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["hover:button-transparent-surface-hover active:button-transparent-surface-active button-base-on-surface-neutral-default hover:button-base-on-surface-neutral-hover active:button-base-on-surface-neutral-active", {
        "!button-base-on-surface-neutral-active !button-transparent-surface-active": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, D = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _
}, Symbol.toStringTag, { value: "Module" })), ee = {
  __name: "TransparentSubtle",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["button-transparent-subtle-on-surface-default hover:button-transparent-subtle-on-surface-hover active:button-transparent-subtle-on-surface-active", {
        "button-transparent-subtle-on-surface-active": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, M = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ee
}, Symbol.toStringTag, { value: "Module" })), te = {
  __name: "TransparentSubtleInvert",
  props: {
    tag: String,
    active: Boolean,
    disabled: Boolean
  },
  setup(e) {
    return (t, r) => (a(), n(u(e.tag), {
      class: s(["button-transparent-subtle-on-surface-invert-default hover:button-transparent-subtle-on-surface-invert-hover active:button-transparent-subtle-on-surface-invert-active", {
        "button-transparent-subtle-on-surface-invert-active": e.active
      }]),
      disabled: e.disabled,
      active: e.active
    }, {
      default: o(() => [
        i(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "active", "class"]));
  }
}, I = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: te
}, Symbol.toStringTag, { value: "Module" }));
export {
  ue as _,
  H as a
};
